module.exports = __webpack_public_path__ + "img/strength-6.df242eab.png";